<template>
	<div class="leftNav ft14">
		<ul class="fColor1">
			<!-- <li v-for="(item,index) in array" :key="index" :class="index == curActive ? 'active' :''" @click="goto(index,item.page)">
				<img :src="index == curActive ? item.src2 : item.src1"/>
				<span>{{item.text}}</span>
			</li> -->
			<li :class="0 == curActive ? 'active' :''" @click="goto(0,'dealFinance')">
				<img v-show="0 == curActive" src="../../assets/images/icon_delegate_s.png" >
				<img v-show="0 != curActive" src="../../assets/images/icon_delegate.png" >
				<span>{{$t('asset.currency_account')}}</span>
			</li>
			<li :class="1 == curActive ? 'active' :''" @click="goto(1,'finance')">
				<img v-show="1 == curActive" src="../../assets/images/icon_delegate_s.png" >
				<img v-show="1 != curActive" src="../../assets/images/icon_delegate.png" >
				<span>{{$t('asset.lever_account')}}</span>
			</li>
			<li :class="2 == curActive ? 'active' :''" @click="goto(2,'micro')">
				<img v-show="2 == curActive" src="../../assets/images/icon_delegate_s.png" >
				<img v-show="2 != curActive" src="../../assets/images/icon_delegate.png" >
				<span>{{$t('asset.miao_account')}}</span>
			</li>
			<!-- <li :class="2 == curActive ? 'active' :''" @click="goto(2,'legal')">
				<img v-show="2 == curActive" src="../../assets/images/icon_delegate_s.png" >
				<img v-show="2 != curActive" src="../../assets/images/icon_delegate.png" >
				<span>{{$t('asset.fince_account')}}</span>
			</li> -->
		</ul>
	</div>
</template>
<script>
	export default {
		name: "left_account",
		data() {
			return {
				curActive:0,
				array:[
					{
						src1: require("@/assets/images/icon_delegate.png"),
						src2: require("@/assets/images/icon_delegate_s.png"),
						text: this.$t('asset.currency_account'),
						page:'dealFinance',
						children:['dealFinance']
					},
					{
						src1: require("@/assets/images/icon_delegate.png"),
						src2: require("@/assets/images/icon_delegate_s.png"),
						text: this.$t('asset.lever_account'),
						page:'finance',
						children:['finance']
					},
					{
						src1: require("@/assets/images/icon_delegate.png"),
						src2: require("@/assets/images/icon_delegate_s.png"),
						text: this.$t('asset.fince_account'),
						page:'legal',
						children:['legal']
					},
					{
						src1: require("@/assets/images/transfer.png"),
						src2: require("@/assets/images/transferSelected.png"),
						text: '资金划转',
						page:'transfer',
						children:['transfer']
					},

				],
			}
		},
		created(){
			let name = this.$route.name;
			this.curActive = this.array.findIndex( val => val.page === name || (val.children && val.children.includes(name))) ;
		},
		mounted(){
			this.bus.$on("nav_name", name =>{
				this.curActive = this.array.findIndex( val => val.page === name || (val.children && val.children.includes(name))) ;
			})
		},
		methods: {
			goto(index,name) {
				this.curActive=index;
				this.$router.push({name: name, params: {lang: this.lang}})
			},

		}
	};
</script>
<style lang="scss" scoped>
	.leftNav{

		ul{
			height:820px;
			li{
				height:54px;
				line-height:54px;
				padding-left:38px;
				margin-bottom:4px;
				cursor:pointer;
				img{
					margin-right:12px;
					margin-top:-4px;
					width:20px;
					vertical-align: middle;
				}
			}
			.active{
				color:rgb(86, 151, 244);
				background-color: rgb(39, 49, 66);
				border-bottom: none;
				display: block;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/accounts/left_account.vue